import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { Droplets, Trash2, Wrench, Truck, ArrowRight } from "lucide-react";
import { WATER_TRUCK_URL, TRUCK_BIN_URL, TRUCK_TRIP_URL } from "@/lib/constants";

const items = [
  { to: "/logistics/water", icon: Droplets, title: "Water Delivery", desc: "Drums · 275 – 3,000 gal tiers", price: "from EC$25", img: WATER_TRUCK_URL, tid: "logi-water" },
  { to: "/logistics/bin", icon: Trash2, title: "Bin Rentals", desc: "Construction & cleanup bins", price: "EC$350", img: TRUCK_BIN_URL, tid: "logi-bin" },
  { to: "/logistics/trucking", icon: Truck, title: "Trucking Services", desc: "Aggregate, sand, gravel, pallets & hauling", price: "Quote", img: TRUCK_TRIP_URL, tid: "logi-trucking" },
  { to: "/logistics/diagnostics", icon: Wrench, title: "Vehicle Diagnostics", desc: "Cars & trucks", price: "from EC$200", img: null, tid: "logi-diag" },
];

export default function LogisticsPage() {
  return (
    <Layout>
      <section className="relative overflow-hidden bg-[#0F172A] text-white">
        <div className="absolute inset-0">
          <img src={WATER_TRUCK_URL} alt="" className="w-full h-full object-cover opacity-50" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0F172A] via-[#0F172A]/80 to-transparent" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-[#FFCE00]">Trucking & Industrial</div>
          <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl mt-3 max-w-3xl">
            Reliable transportation &amp; essential services across Antigua &amp; Barbuda.
          </h1>
          <p className="mt-4 text-slate-200 max-w-2xl">
            Book water, bins, diagnostics, or trucking online in minutes. Fixed XCD pricing, instant confirmations.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-2 gap-6">
        {items.map((it) => (
          <Link key={it.to} to={it.to} data-testid={it.tid}
                className="group block bg-white border border-slate-200 rounded-md overflow-hidden hover:border-slate-400 hover:-translate-y-1 transition-all">
            <div className="grid grid-cols-5">
              <div className="col-span-2 relative bg-slate-100 min-h-[180px]">
                {it.img ? (
                  <img src={it.img} alt={it.title} className="w-full h-full object-cover" />
                ) : (
                  <div className="absolute inset-0 bg-gradient-to-br from-[#1D4ED8] to-[#0F172A] flex items-center justify-center">
                    <it.icon className="h-16 w-16 text-white/80" strokeWidth={1.5} />
                  </div>
                )}
              </div>
              <div className="col-span-3 p-6">
                <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#1D4ED8]">{it.price}</div>
                <div className="flex items-center gap-2 mt-2 text-slate-900">
                  <it.icon className="h-6 w-6 text-[#E32636]" strokeWidth={2.5} />
                  <span className="font-heading font-bold text-xl">{it.title}</span>
                </div>
                <p className="text-sm text-slate-600 mt-2">{it.desc}</p>
                <div className="mt-4 inline-flex items-center gap-1 font-bold text-slate-900">
                  Book now <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </section>
    </Layout>
  );
}
